import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import Product from "../../model/product.model";
import {CurrencyComponent} from "../currency/currency.component";

@Component({
    selector: 'app-product-price-display',
    imports: [
        CurrencyComponent,
    ],
    templateUrl: './product-price-display.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './product-price-display.component.scss'
})
export class ProductPriceDisplayComponent {
  @Input() public product!: Product;
}
